module.exports = __webpack_public_path__ + "img/L34_FunctionRoom-6K-3.b7a380f7.gif";